import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'
import { AppTypesState } from './types'
import { IAppType } from '@/types/app-type.interface'

const initialState: AppTypesState = {
  list: [],
}

const appTypesSlice = createSlice({
  name: 'app-types',
  initialState,
  reducers: {
    setAppTypes: (state, action: PayloadAction<IAppType[]>) => {
      state.list = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state, action) => {
      return {
        ...state,
        // @ts-ignore
        ...action.payload.appTypes,
      }
    })
  },
})

export const { setAppTypes } = appTypesSlice.actions

export default appTypesSlice
